import { render, staticRenderFns } from "./AssetSelector.vue?vue&type=template&id=84123466"
import script from "./AssetSelector.vue?vue&type=script&lang=js"
export * from "./AssetSelector.vue?vue&type=script&lang=js"
import style0 from "./vue-select-image.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports